import React from "react";
import PropTypes from "prop-types";
import { graphql } from "@apollo/client/react/hoc";
import ThemeProvider from "./ThemeProvider";
import { getTheme } from "utils/themes";

const GqlThemeProvider = (props) => {
  const { query, options, ...rest } = props;
  const ThemeProviderWrapper = React.memo(
    graphql(query, {
      options,
      props: ({ data: { tenantTheme, loading, refetch } }) => {
        const gqlThemeContent = tenantTheme && tenantTheme.content;
        if (gqlThemeContent) return { theme: JSON.parse(gqlThemeContent), loading, ...rest };
        const gqlThemeCode = tenantTheme && tenantTheme.code;
        const theme = gqlThemeCode && getTheme(gqlThemeCode);
        return { theme: theme, loading, refetch, ...rest };
      },
    })(ThemeProvider)
  );
  return <ThemeProviderWrapper />;
};

GqlThemeProvider.propTypes = {
  query: PropTypes.any,
  options: PropTypes.any,
};

export default GqlThemeProvider;
